"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "S3Client", {
  enumerable: true,
  get: function () {
    return _s3Client.S3Client;
  }
});
var _s3Client = require("./s3Client");